import {
    faBrain,
    faBullseye,
    faClipboardCheck,
    faCalendarDays,
    faChartLine,
    faRocket,
    faHeartPulse,
} from "@fortawesome/free-solid-svg-icons";

export const pdStory = [
    {
        title: "5W1H Framework",
        icon: faBrain,
        color: "purple",
        content: [
            "What: 90 day transformation",
            "Why: Consistency beats motivation",
            "Who: Anyone seeking improvement",
            "When: 90 Days",
            "Where: Anywhere",
            "How: Small meaningful daily actions",
        ],
    },
    {
        title: "Day 0 - Objective",
        icon: faBullseye,
        color: "yellow",
        content: [
            "Lose 5kg",
            "Improve sleep",
            "Increase focus",
            "Become more disciplined",
        ],
    },
    {
        title: "Daily Todo Examples",
        icon: faClipboardCheck,
        color: "green",
        content: [
            "Walk 30 Minutes (Health, Fitness)",
            "Drink 2 Litres Water (Health, Wellness)",
            "Sleep Before 11 PM (Sleep, Discipline)",
        ],
    },
    {
        title: "Week 1 Review",
        icon: faCalendarDays,
        color: "blue",
        content: [
            "Completion Rate: 86%",
            "Better energy",
            "Improved hydration",
            "Late night mobile usage detected",
        ],
    },
    {
        title: "Month 1 Review",
        icon: faChartLine,
        color: "cyan",
        content: [
            "Weight Loss: 1.5kg",
            "Stability Score: 72/100",
            "Walking becoming routine",
        ],
    },
    {
        title: "Month 2 Review",
        icon: faRocket,
        color: "orange",
        content: [
            "Weight Loss: 3.5kg",
            "Stability Score: 84/100",
            "Habits require less effort",
        ],
    },
    {
        title: "Day 90 Transformation",
        icon: faHeartPulse,
        color: "red",
        content: [
            "Better Health",
            "Better Focus",
            "Higher Confidence",
            "Strong Discipline",
            "Improved Self Awareness",
        ],
    },
];